import z from "zod";
export const IsoWeekdaySchema = z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
]);
/** Named days, so a call site never has to know which end the week starts. */
export const ISO_WEEKDAY = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7,
};
const DAYS_PER_WEEK = 7;
/**
 * The weekday `dayOffset` days after `weekday`, wrapping through Sunday; a
 * negative offset counts backwards.
 */
export function addDaysToIsoWeekday(weekday, dayOffset) {
    // `%` keeps the sign of its left operand, so a negative sum needs lifting
    // back into the week before the ISO numbering's +1.
    const daysAfterMonday = (((weekday - 1 + dayOffset) % DAYS_PER_WEEK) + DAYS_PER_WEEK) %
        DAYS_PER_WEEK;
    return (daysAfterMonday + 1);
}
/** The ISO weekday of `date`, in the zone `date` is already in. */
export function isoWeekdayOf(date) {
    return IsoWeekdaySchema.parse(date.isoWeekday());
}
//# sourceMappingURL=weekday.js.map